<template>
  <div>
    <Confirm ref="confirm" />
    <v-simple-table>
      <thead>
        <tr>
          <th>{{ $t('offerDetails.client') }}</th>
          <th>{{ $t('offerDetails.route') }}</th>
          <th>{{ $t('offerDetails.content') }}</th>
          <th>{{ $t('offerDetails.createdAt') }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="interest in interests" :key="interest.id">
          <td>
            <div>{{ interest.clientName }}</div>
          </td>
          <td>
            <div>{{ interest.loadingPlace || '—' }}</div>
            <div class="lightText--text">{{ interest.unloadingPlace || '—' }}</div>
          </td>
          <td>
            <span>{{ interest.content || '—' }}</span>
          </td>
          <td>
            {{ interest.createdAt | dateFormat('DD.MM.YYYY HH:mm') }}
          </td>
          <td>
            <div class="d-flex align-center justify-end">
              <div
                v-if="showOfferDetailsIcon && interest.orderId"
                class="d-flex align-center pointer mr-2"
                @click.stop="openOfferDetails(interest)"
              >
                <v-icon size="25" color="primary">$infoBox</v-icon>
              </div>
              <DataTablePopupCell
                v-if="interest.clientPhone"
                :phone="interest.clientPhone"
                :click-type="ClickPhone"
                :order-id="interest.orderId"
                class="mr-2"
              />
              <DataTablePopupCell
                v-if="interest.clientEmail"
                :email="interest.clientEmail"
                :click-type="ClickEmail"
                :subject-text="interestMailSubject(interest)"
                :order-id="interest.orderId"
                class="mr-2"
              />
              <v-chip v-if="interest.isNew" x-small color="primary" text-color="white" class="mr-2">
                {{ $t('offerDetails.new') }}
              </v-chip>
              <template v-if="showArchiveActions">
                <v-btn
                  v-if="!interest.isOrderArchived"
                  small
                  color="error"
                  outlined
                  @click.stop="archiveInterest(interest)"
                >
                  {{ $t('spedilink.links.archiveOffer') }}
                </v-btn>
                <span v-else class="lightText--text">{{ $t('spedilink.links.archivedOffer') }}</span>
              </template>
            </div>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <OfferDetailsDialog
      v-if="selectedOfferId"
      :value="offerDetailsActive"
      :item-id="selectedOfferId"
      :is-vehicle="selectedIsVehicle"
      @closed="onOfferDetailsClosed"
    />
  </div>
</template>

<script>
import DataTablePopupCell from '@/components/DataTablePopupCell'
import { Phone as ClickPhone, Email as ClickEmail } from '@/types/click-order-types.js'
import Confirm from '@/components/dialogs/Confirm.vue'
import Service from '@/services'

export default {
  name: 'SpedilinkInterestsPanel',
  components: {
    DataTablePopupCell,
    Confirm,
    OfferDetailsDialog: () => import('@/views/Market/dialogs/OfferDetailsDialog.vue')
  },
  props: {
    interests: {
      type: Array,
      default: () => []
    },
    showArchiveActions: {
      type: Boolean,
      default: false
    },
    showOfferDetailsIcon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      ClickPhone,
      ClickEmail,
      loading: false,
      offerDetailsActive: false,
      selectedOfferId: null,
      selectedIsVehicle: false
    }
  },
  methods: {
    openOfferDetails (interest) {
      if (!interest.orderId) {
        return
      }
      this.selectedOfferId = String(interest.orderId)
      this.selectedIsVehicle = (interest.orderType || '') === 'Vehicle'
      this.offerDetailsActive = true
    },
    interestMailSubject (row) {
      const from = (row.loadingPlace || '').trim()
      const to = (row.unloadingPlace || '').trim()
      if (!from && !to) {
        return ''
      }
      if (!from) {
        return to
      }
      if (!to) {
        return from
      }
      return `${from} - ${to}`
    },
    onOfferDetailsClosed () {
      this.offerDetailsActive = false
      this.selectedOfferId = null
    },
    async archiveInterest (interest) {
      const confirmed = await this.$refs.confirm.open(
        this.$t('spedilink.links.archiveOfferTitle'),
        this.$t('spedilink.links.archiveOfferMessage')
      )
      if (!confirmed) {
        return
      }
      this.loading = true
      try {
        await Service.post('Order/Reject', {
          orderId: interest.orderId
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('spedilink.links.archiveOfferSuccess'))
        this.$emit('interest-archived', interest)
      } catch (e) {
        console.error('Error archiving interest:', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
  .v-chip__content:not(.v-icon) {
    word-wrap: break-word;
    width: inherit;
    max-width: inherit;
    margin-right: 0;
    padding-right: 0;
  }
</style>
